import React from "react";

import type { ActivityContentGoalTargetUpdating } from "@/api";
import type { Activity } from "@/models/activities";
import { Paths } from "@/routes/paths";
import { Trans } from "../i18n";
import { activityAuthorName, goalLink } from "../feedItemLinks";
import type { ActivityHandler, FeedItemProps } from "../interfaces";

const GoalTargetUpdating: ActivityHandler = {
  pageHtmlTitle(_activity: Activity) {
    throw new Error("Not implemented");
  },

  pagePath(_paths: Paths, _activity: Activity) {
    throw new Error("Not implemented");
  },

  PageTitle(_props: { activity: any }) {
    throw new Error("Not implemented");
  },

  PageContent(_props: { activity: Activity }) {
    throw new Error("Not implemented");
  },

  PageOptions(_props: { activity: Activity }) {
    return null;
  },

  FeedItemTitle({ activity, page, paths }: FeedItemProps) {
    const goal = content(activity).goal;
    const targetName = content(activity).targetName;

    if (page === "goal") {
      return (
        <Trans
          i18nKey="{{author}} updated the value for the {{targetName}} target"
          values={{ author: activityAuthorName(activity), targetName }}
        />
      );
    } else {
      return (
        <Trans
          i18nKey="{{author}} updated the value for the {{targetName}} target on the <goal>{{goalName}}</goal>"
          values={{ author: activityAuthorName(activity), targetName, goalName: goal.name }}
          components={{ goal: goalLink(paths, goal) }}
        />
      );
    }
  },

  FeedItemContent({ activity }: { activity: Activity }) {
    const oldValue = content(activity).oldValue;
    const newValue = content(activity).newValue;
    const unit = content(activity).unit;

    return (
      <Trans
        i18nKey="Previously, {{oldValue}} {{unit}}, now {{newValue}} {{unit}}."
        values={{ oldValue, newValue, unit }}
      />
    );
  },

  feedItemAlignment(_activity: Activity): "items-start" | "items-center" {
    return "items-center";
  },

  commentCount(_activity: Activity): number {
    throw new Error("Not implemented");
  },

  hasComments(_activity: Activity): boolean {
    throw new Error("Not implemented");
  },

  NotificationTitle(_props: { activity: Activity }) {
    return <></>;
  },

  NotificationLocation(_props: { activity: Activity }) {
    return null;
  },
};

function content(activity: Activity): ActivityContentGoalTargetUpdating {
  return activity.content as ActivityContentGoalTargetUpdating;
}

export default GoalTargetUpdating;
